import React from 'react';
import { Route } from 'react-router-dom';
import { DeliveriesLoadingDialog } from './deliveries-loading-dialog/DeliveriesLoadingDialog';
import { DeliverDeleteDialog } from './deliver-delete-dialog/DeliverDeleteDialog';
import { DeliveriesUIProvider } from './DeliveriesUIContext';
import DeliveriesCard from './DeliveriesCard';

const DeliveriesPage = ({ history }) => {
  const DeliveriesUIEvents = {
    openCreateDeliverDialog: () => {
      history.push('/deliveries/new');
    },
    openViewDeliverDialog: (id) => {
      history.push(`/deliveries/${id}/edit`);
    },
    openDeleteDeliverDialog: (id) => {
      history.push(`/deliveries/${id}/delete`);
    },
  };

  return (
    <DeliveriesUIProvider DeliveriesUIEvents={DeliveriesUIEvents}>
      <DeliveriesLoadingDialog />
      <Route path='/deliveries/:id/delete'>
        {({ history, match }) => (
          <DeliverDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/deliveries');
            }}
          />
        )}
      </Route>
      <DeliveriesCard props />
    </DeliveriesUIProvider>
  );
};

export default DeliveriesPage;
